/*
  Miamon — gesto de arrastre compartido por los tres carruseles
  (hero, reels y testimonios).

  Los tres avanzan por pasos, no por desplazamiento continuo, así que no hace
  falta seguir el dedo en tiempo real: basta con decidir al soltar. Lo que sí
  hacía falta, y es justo lo que faltaba, son cuatro cosas:

  1. `touch-action: pan-y` en la superficie. Sin esto el navegador se queda el
     gesto horizontal para hacer scroll y nos manda `pointercancel` antes de
     llegar al `pointerup`: en móvil el arrastre no funcionaba NUNCA, daba
     igual el umbral. Es el motivo real de que no fuese arrastrable.
  2. Exigir intención horizontal (|dx| > |dy|) antes de apropiarse del gesto,
     para no robarle a la página su scroll vertical.
  3. `setPointerCapture` en cuanto el gesto es nuestro, para seguir recibiendo
     eventos aunque el dedo se salga de la tarjeta donde empezó.
  4. Tragarse el `click` que el navegador dispara al soltar. Sin esto, soltar
     encima de una tarjeta abría su enlace o la recentraba.

  Uso:  mmArrastre(superficie, function (dir) { ... })   // dir: 1 = siguiente
*/
window.mmArrastre = function (superficie, alSoltar) {
  if (!superficie || typeof alSoltar !== 'function') return;

  var UMBRAL = 40; // px de recorrido para que cuente como arrastre
  var INTENCION = 10; // px a partir de los cuales se decide la dirección

  var x0 = 0;
  var y0 = 0;
  var activo = false;
  var nuestro = false; // el gesto ya se ha reconocido como horizontal

  // Se declara desde aquí y no desde el CSS para que no se pueda quedar
  // suelto: sin esta línea el resto del módulo no sirve de nada.
  superficie.style.touchAction = 'pan-y';

  // Las <img> y los <a href> son arrastrables de serie: al mover el ratón
  // sobre ellos el navegador arranca SU drag-and-drop nativo y nos cancela
  // la secuencia de puntero, así que el `pointerup` no llega nunca. Se nota
  // solo donde hay imágenes o enlaces dentro — en el carrusel del hero, no
  // en reels ni testimonios. `dragstart` burbujea, así que basta con uno.
  superficie.addEventListener('dragstart', function (evento) {
    evento.preventDefault();
  });

  superficie.addEventListener('pointerdown', function (evento) {
    // Solo botón principal; en táctil y lápiz `button` vale 0 igualmente.
    if (evento.button !== 0) return;
    activo = true;
    nuestro = false;
    x0 = evento.clientX;
    y0 = evento.clientY;
  });

  superficie.addEventListener('pointermove', function (evento) {
    if (!activo || nuestro) return;
    var dx = evento.clientX - x0;
    var dy = evento.clientY - y0;
    if (Math.abs(dx) < INTENCION || Math.abs(dx) <= Math.abs(dy)) return;

    nuestro = true;
    superficie.classList.add('is-dragging');
    try {
      superficie.setPointerCapture(evento.pointerId);
    } catch (e) {
      /* el navegador puede negarse; el gesto sigue funcionando sin captura */
    }
  });

  var soltar = function (evento) {
    if (!activo) return;
    activo = false;
    superficie.classList.remove('is-dragging');
    if (!nuestro) return;
    nuestro = false;

    var dx = evento.clientX - x0;
    if (Math.abs(dx) < UMBRAL) return;

    alSoltar(dx < 0 ? 1 : -1);

    // El navegador dispara un `click` justo después de soltar. Se intercepta
    // en fase de captura (llega antes que los listeners de las tarjetas) y se
    // retira solo, para no comerse un clic legítimo posterior.
    var tragar = function (ev) {
      ev.preventDefault();
      ev.stopPropagation();
    };
    superficie.addEventListener('click', tragar, true);
    setTimeout(function () {
      superficie.removeEventListener('click', tragar, true);
    }, 320);
  };

  superficie.addEventListener('pointerup', soltar);

  superficie.addEventListener('pointercancel', function () {
    activo = false;
    nuestro = false;
    superficie.classList.remove('is-dragging');
  });
};
